import { formatStorageDuration } from '../../utils/storageDateTime';

/** U21: a seconds field says what it means in words ("604800 = 7 days"), the unit kept on its number. */
export function DurationEcho({ seconds }: { seconds: number }) {
  if (!Number.isFinite(seconds)) return null;
  return <span className="mt-0.5 block text-xs text-muted-foreground" data-testid="queue-duration-echo">= {formatStorageDuration(seconds)}</span>;
}
